import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.veranstaltung-benutzerverwaltung-rolle-berechtigungen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungBenutzerverwaltungRolleBerechtigungenEffects {

    VeranstaltungBenutzerverwaltungRolleBerechtigungen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNG_BENUTZERVERWALTUNG_ROLLE_BERECHTIGUNGEN),
        mergeMap((x: ac.GetVeranstaltungBenutzerverwaltungRolleBerechtigungenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungBenutzerverwaltungRolleBerechtigungen(x.rolle_id).pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungBenutzerverwaltungRolleBerechtigungenErfolgreichAction(result, x.rolle_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungBenutzerverwaltungRolleBerechtigungenFehlerAction(error, x.rolle_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerVerwaltungExtensionQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerVerwaltungExtensionQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerVerwaltungExtensionQueryService);
        }
        return this.service;
    }
}
